<template>
  <div>
    <el-container>
      <el-aside width="auto">
        <CommonAside></CommonAside>
      </el-aside>
      <el-container>
        <el-header><CommonHeader></CommonHeader></el-header>
        <el-main style="overflow: auto;height:89vh;background-color: #f5f5f5;">
          <CommonTag></CommonTag>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import CommonAside from '@/components/CommonAside';
import CommonHeader from '@/components/CommonHeader';
import CommonTag from '@/components/CommonTag';
export default {
  name: "Main",
  components:{
    CommonAside,CommonHeader,CommonTag
  }
};
</script>

<style>
.el-header{
  padding: 0;
}
</style>